import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const HeartIcon = createIcon({
  displayName: 'HeartIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.696,4c3.175,0 5.304,2.98 5.304,5.755c0,5.633 -8.839,10.245 -9,10.245c-0.161,0 -9,-4.612 -9,-10.245c0,-2.775 2.129,-5.755 5.304,-5.755c1.815,0 3.007,0.905 3.696,1.711c0.689,-0.806 1.881,-1.711 3.696,-1.711Z"
        ></path>
      </g>
    </>
  ),
})

const Heart: FC<IconProps> = (props) => {
  return <CustomIcon as={HeartIcon} {...props} />
}

export default memo(Heart)
